// src/utils/uploadImage.js
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

function dataURLtoBlob(dataURL) {
  const [meta, base64] = dataURL.split(',');
  const mime = meta.match(/:(.*?);/)[1];
  const binary = atob(base64);
  const array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }
  return new Blob([array], { type: mime });
}

export const uploadImageAndGetURL = async (base64Image, puzzleId) => {
  const blob = dataURLtoBlob(base64Image);
  const storageRef = ref(storage, `puzzles/${puzzleId}.jpg`);

  const metadata = {
    contentType: blob.type || 'image/jpeg',
    cacheControl: 'public,max-age=3600',
  };

  await uploadBytes(storageRef, blob, metadata);
  return await getDownloadURL(storageRef);
};
